module.exports = __webpack_public_path__ + "img/Icon-10.6879d2fd.png";